import { AbstractToolbarProps } from "@itwin/appui-abstract";

import { PopupToolbarProvider } from "./ToolbarPopup";
import { cIssue } from "./Issues";
import { cIssuesUi } from "./IssuesUi";
import { cIssueDlg } from "./IssuesDlg";

export class cIssuesToolbar implements PopupToolbarProvider {
  delayPopup: number = 500;
  delayClose: number = 3000;

  public get toolbarProps(): AbstractToolbarProps {
    return {
      items: [
        {
          id: "edit-issue",
          itemPriority: 10,
          label: "Edit Issue",
          icon: "icon-edit",
          execute: () => {},
          isDisabled: false,
        },
        {
          id: "goto-issue",
          itemPriority: 20,
          label: "Go To Issue",
          icon: "icon-zoom-in-2",
          execute: () => {},
          isDisabled: false,
        },
        // {
        //   id: "delete-issue",
        //   itemPriority: 30,
        //   label: "Delete Issue",
        //   icon: "icon-delete",
        //   execute: () => {},
        //   isDisabled: false,
        // },
      ],
    };
  }

  public itemExecuted = async (id: string, commandId: string) => {

    const issue = cIssue.getIssueById(Number(id));
    if (!issue) return;

    switch (commandId) {
      case "edit-issue":
        cIssueDlg.updateIssue(issue);
        break;
      case "goto-issue":
        cIssuesUi.goToIssue(issue);
        break;
      case "delete-issue":
        cIssue.deleteIssue(Number(id));
        break;
    }
  }
}
